import React from "react";
import Badge from "../PublicPage/Rating/badge";
import { getBadges } from "../../Helper";
import { Grid } from "@mui/material";
import InfiniteScroll from "react-infinite-scroller";

const TeacherComplimentsBadge = ({
  comments,
  fetchFeedback,
  hasMore,
  badges,
}) => {
  const badges_data = getBadges();

  const getBadgeData = (title) => {
    title = title.toLowerCase().split(" ").join("");
    let icon_path = "";
    let titleDisplay = "";
    for (let i = 0; i < badges_data.length; i++) {
      let badgesTitle = badges_data[i].badge_title
        .toLowerCase()
        .split(" ")
        .join("");
      if (title === badgesTitle) {
        icon_path = badges_data[i].icon_path;
        titleDisplay = badges_data[i].badge_title;
      }
    }
    return { icon_path, titleDisplay };
  };

  const BadgeArray = badges.map((badge) => {
    return (
      <Grid
        sx={{
          ".badge-container": {
            width: "100%",
            margin: "0px",
          },
        }}
        className="flex justify-center"
        item
        xs={4}
        lg={comments?.length <= 0 ? 12 / 5 : 3}
      >
        <Badge
          title={badge.title}
          iconURL={getBadgeData(badge.title).icon_path}
          number={badge.count}
          activeClass={false}
        />
      </Grid>
    );
  });
  return (
    <Grid sx={{ padding: "0px 16px" }} spacing={2} container>
      <Grid
        // sx={{ margin: "0px 10px 10px 20px" }}
        item
        xs={12}
        lg={comments?.length <= 0 ? 12 : 7}
        className=""
      >
        <Grid spacing={{ xs: 1, lg: 3 }} container>
          {BadgeArray}
        </Grid>
      </Grid>
      <Grid item xs={12} lg={5}>
        <div
          className="infinite-scroll"
          style={{
            overflow: "auto",
            height: "100%",
            maxHeight: comments?.length <= 0 ? "0px" : "500px",
          }}
        >
          <InfiniteScroll
            pageStart={0}
            initialLoad
            loadMore={fetchFeedback}
            hasMore={hasMore}
            loader={
              <div className="loader" key={0}>
                ...
              </div>
            }
            useWindow={false}
          >
            {comments?.map((comment) => (
              <div className="comment-container">
                <p className="font-bold mb-2 text-md">
                  {comment?.customer_name},{comment?.createdAt}
                </p>
                <p className="font-medium">{comment?.detail}</p>
              </div>
            ))}
          </InfiniteScroll>
        </div>
      </Grid>
    </Grid>
  );
};

export default TeacherComplimentsBadge;
